import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const Input: React.FC<InputProps> = ({ className = '', ...props }) => {
  return (
    <input
      className={`w-full px-4 py-2.5 rounded-xl border border-outline-variant/30 bg-surface text-on-surface focus:outline-none focus:border-heritage-red focus:ring-1 focus:ring-heritage-red transition-colors ${className}`}
      {...props}
    />
  );
};

